import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const HeartIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="var(--amber)"
    aria-hidden="true"
  >
    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
  </svg>
);

const PhoneIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="var(--amber)"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 01.03 2.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
  </svg>
);

const MailIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="var(--amber)"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

const GlobeIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="var(--amber)"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" />
  </svg>
);

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container footer-grid">
          <div className="footer-brand">
            <div className="footer-logo-wrap">
              <img
                src="/images/logo.png"
                alt="Food and Nutrition Foundation"
                className="footer-logo"
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextSibling.style.display = "block";
                }}
              />
              <span
                className="footer-logo-fallback"
                style={{ display: "none" }}
              >
                <span className="logo-fallback-icon-footer">FNF</span>
              </span>
            </div>
            <p className="footer-tagline">Bringing Real Hope</p>
            <p className="footer-desc">
              Fighting hunger and starvation in vulnerable communities through
              nutrition, education, and care since 2008.
            </p>
            <Link
              to="/donate"
              className="btn btn-primary btn-sm footer-donate-btn"
            >
              Donate Now
            </Link>
          </div>

          <div className="footer-links-col">
            <h4>Our Work</h4>
            <ul>
              <li>
                <Link to="/what-we-do/feeding-programme">
                  Feeding Programme
                </Link>
              </li>
              <li>
                <Link to="/what-we-do/nutrition-education">
                  Nutrition Education
                </Link>
              </li>
              <li>
                <Link to="/what-we-do/school-sponsorship">
                  School Sponsorship
                </Link>
              </li>
              <li>
                <Link to="/what-we-do/home-based-care">Home-Based Care</Link>
              </li>
              <li>
                <Link to="/what-we-do/skills-training">Skills Training</Link>
              </li>
              <li>
                <Link to="/what-we-do/early-childhood-development">
                  Early Childhood Development
                </Link>
              </li>
              <li>
                <Link to="/what-we-do/orphans-and-vulnerable-children">
                  Orphans &amp; Vulnerable Children
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-links-col">
            <h4>Organisation</h4>
            <ul>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/where-we-are-located">Where We Are Located</Link>
              </li>
              <li>
                <Link to="/our-impact">Our Impact</Link>
              </li>
              <li>
                <Link to="/gallery">Gallery</Link>
              </li>
              <li>
                <Link to="/staff">Staff &amp; Volunteers</Link>
              </li>
              <li>
                <Link to="/board">Board of Directors</Link>
              </li>
              <li>
                <Link to="/get-involved">Get Involved</Link>
              </li>
              <li>
                <Link to="/contact">Contact Us</Link>
              </li>
            </ul>
          </div>

          <div className="footer-contact-col">
            <h4>Secretariat — South Africa</h4>
            <ul className="footer-contact-list">
              <li>
                <PhoneIcon />
                <a href="tel:+270653855857">+27 82 330 2294</a>
              </li>
              <li>
                <MailIcon />
                <a href="mailto:admin@foodnutritionfoundation.com">
                  admin@foodnutritionfoundation.com
                </a>
              </li>
              <li>
                <GlobeIcon />
                <a
                  href="https://foodnutritionfoundation.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  foodnutritionfoundation.com
                </a>
              </li>
            </ul>

            <h4 style={{ marginTop: "1.5rem" }}>Zambia Operations</h4>
            <ul className="footer-contact-list">
              <li>
                <PhoneIcon />
                <a href="tel:+260975692169">+260 76 576 5255</a>
              </li>
              <li
                style={{
                  color: "rgba(255,255,255,0.6)",
                  fontSize: "0.85rem",
                  paddingLeft: "1.5rem",
                }}
              >
                Kamanga Compound, Lusaka, Zambia
              </li>
            </ul>

            <div className="footer-store">
              <GlobeIcon />
              <div>
                <p
                  style={{
                    color: "rgba(255,255,255,0.7)",
                    fontSize: "0.8rem",
                    margin: 0,
                  }}
                >
                  Skills Programme Store
                </p>
                <a
                  href="https://bulungu.co.za"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-store-link"
                >
                  bulungu.co.za
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p>
            © {new Date().getFullYear()} Food and Nutrition Foundation. All
            rights reserved. Reg. Zambia.
          </p>
          <p className="footer-made-with">
            Brining Real Hope <HeartIcon /> For The Communities We Serve
          </p>
        </div>
      </div>
    </footer>
  );
}
